angular.module('leftPaneModule')
  .controller('LeftPaneGuardianController', [
    '$scope',
    '$rootScope',
    '$state',
    '$filter',
    'cancelableResourceManager',
    'guardianApi',
    'studentApi',
    'navigationApi',
    'authentication',
    'narrativeFilter',
    'edxReportItemService',
    '$log',
    function (
      $scope,
      $rootScope,
      $state,
      $filter,
      $cancelableResourceManager,
      $guardianApi,
      $studentApi,
      $navigationApi,
      dblAuthentication,
      narrativeFilter,
      reportItemService,
      $log
    ) {

      $scope.consumers = {
          list: [],
          selected: {}
      };

      $scope.imageLoading = true;

      $scope.viewType = dblAuthentication.growthAsFraction()  ? 'fractionMode' : 'percentMode';

      var setNarratives = function(item) {
          $scope.narratives = '';

          _.each(item.status_reason_codes, function(code) {
              var narrative = '<p>' + narrativeFilter(code, $scope.item.type, $scope.consumers.selected.first_name) + '</p>';
              $scope.narratives = $scope.narratives.concat(narrative);
          });
      };

      // Student Object
      var updateStudentData = function (student) {
          return $studentApi.getStudentDataForGuardian(student.id, student.district_id).then(function (studentData) {
              $scope.studentData = studentData;
              setNarratives($scope.studentData);

              return studentData;
          });
      };

      // Guardian Object
      var lastItem;
      var initializeData = function (item) {
          if (lastItem === item) {
            $log.debug('initializeData - Duplicate item');
            return;
          }
          $log.debug('initializeData - item updated');
          $scope.item = item;

          $scope.viewType = dblAuthentication.growthAsFraction()  ? 'fractionMode' : 'percentMode';

          initializeListData();
      };

      var updateStateParams = function () {
          $state.go('.', {
                'studentDistrictId': $scope.consumers.selected.district_id,
                'studentId': $scope.consumers.selected.id
            }, {location: 'replace', notify: false})
            .then(function () {
                  updateStudentData($scope.consumers.selected);
                  $rootScope.$broadcast('updateStudentDataForGuardian');
              },
              function () {
                  $log.warn('Failed to update state parameters');
              });
      };

      var initializeListData = function () {

          // @TODO: Fix extra call
          // On page reload controller is instantiated after master.js broadcasts the list and the consumers list gets reset.
          // Ideally, we just listen for 'itemListReady' broadcasted from master.js
          var type = $state.current.name;
          var params = $state.params;

          $navigationApi.getList(type, params, false, function(list) {
              var consumer_list = angular.copy(list);
              $scope.consumers.list = $filter('orderBy')(consumer_list, 'first_name', $state.params.order === 'asc');

              if ($state.params.studentId) {

                  // param set: update selected from studentId param
                  $scope.consumers.selected = _.find($scope.consumers.list, function (obj) {
                      return obj.id === parseInt($state.params.studentId);
                  });

              } else {
                  // param not set: update selected using first item in list
                  $scope.consumers.selected = $scope.consumers.list[0];
              }

              // $watch when the student is selected from the dropdown
              $scope.$watch('consumers.selected', function () {
                  $scope.imageLoading = true;
                  updateStateParams();
              });
          });
      };

      $scope.setLoaded = function () {
          $scope.imageLoading = false;
      };

      $scope.$watch('studentData.years', function (years) {
          if (years) {
              $rootScope.$broadcast('updateYears', years);
          }
      });

      $log.debug('Subscribing to item');
      var itemSubscription = reportItemService.getItemObservable().subscribe(initializeData);

      $scope.$on('$destroy', function () {
        itemSubscription.dispose();
      });

      $rootScope.$watch('errors', function () {
          $scope.errors = _.find($rootScope.errors, function (obj) {
              return obj.type === 'consumerStudentList';
          });
      });

  }]);
